import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'thirdParty',
      type: 'select',
      label: '所属第三方',
      placeholder: '请选择所属第三方',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'datetimerange',
        'value-format': 'YYYY-MM-DD HH:mm:ss',
        defaultTime: [
          new Date(2000, 1, 1, 0, 0, 0),
          new Date(2000, 1, 1, 23, 59, 59)
        ]
      }
    },
    // {
    //   field: 'cfddFlag',
    //   type: 'switch',
    //   label: '重复兜底',
    //   activeValue: true,
    //   inActiveValue: false
    // }
  ]
}

